<template>
  <div class="switch_demo">
    <SjSwitch v-model="value" label="label" />
    <SjSwitch v-model="value" size="small" />
    <SjSwitch v-model="value" size="small" disabled label="禁用label" />
    <SjSwitch v-model="value" loading label="loading Label" />
    <SjSwitch
      v-model="value"
      size="small"
      loading
      label="small loading Label"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      value: false
    };
  }
};
</script>

<style scoped lang="less">
.switch_demo {
  display: flex;
  flex-direction: column;
  > * {
    margin-bottom: 10px;
  }
}
</style>
